"use client";

import { useEffect, useState } from "react";
import "./index.css";
import ProtocolTable from "./ProtocalTable";
import Disclaimer from "./Disclaimer";

const CKDPatientReport = (props) => {
  const [apidata, setAPI] = useState();

  useEffect(() => {
    const report = props.data.data;
    setAPI(report);
  }, [props]);



  return (
    <div>
      {apidata && (
        <div className="new-report-container">
          <div className="new-report-card">
            <h2 className="report-card-title">
              AI Calculated Risk Score Based on Your Inputs
            </h2>
            <div className="risk-section">
              <div className="risk-cards ckd-risk-cards">
                <div className="risk-card">
                  <h3 className="risk-card-title">Current CKD Stage</h3>
                  <div
                    className={`risk-highlight`}
                    style={{ color: "black", border: "1px solid lightgray" }}
                  >
                    {apidata.current_ckd_stage}
                  </div>
                </div>
                <div className="risk-card">
                  <h3 className="risk-card-title">Predicted Risk Score</h3>
                  <div
                    className={`risk-highlight`}
                    style={{ color: "black", border: "1px solid lightgray" }}
                  >
                    {typeof apidata?.classification_model?.confidence === "number"
                      ? apidata.classification_model.confidence.toFixed(3)
                      : apidata?.classification_model?.confidence || apidata?.confidence || "-"}
                  </div>
                </div>
                <div className="risk-card">
                  <h3 className="risk-card-title">
                    Predicted Category of Progression
                  </h3>
                  <p className="risk-value">
                    <span
                      className={`risk-highlight risk-status-value ${
                        apidata["predicted_category_of_progression"] ===
                        "Severe Progression"
                          ? "red-bg"
                          : apidata["predicted_category_of_progression"] ===
                            "Mild Progression"
                          ? "green-bg"
                          : "yellow-bg"
                      }`}
                    >
                      {apidata["predicted_category_of_progression"]}
                    </span>
                  </p>
                </div>
                <div className="risk-card">
                  <h3 className="risk-card-title">
                    Predicted rate of Deterioration
                  </h3>
                  <p className="risk-value">
                    <span className="risk-number">
                      {typeof apidata["predicted_rate_of_det"] === "number"
                        ? apidata["predicted_rate_of_det"].toFixed(3)
                        : apidata["predicted_rate_of_det"]}{" "}
                      mL/min/1.73 m² / year
                    </span>
                  </p>
                </div>
              </div>
              <p className="note-items" style={{ marginBottom: "6px" }}>
                <span>
                  Predicted Rate of Deterioration Range (Sigma):{" "}
                  <strong>
                    {Array.isArray(apidata["predicted_rate_of_det_range_sigma"])
                      ? `${apidata["predicted_rate_of_det_range_sigma"][0].toFixed(3)} - ${apidata["predicted_rate_of_det_range_sigma"][1].toFixed(3)}`
                      : apidata["predicted_rate_of_det_range_sigma"]}{" "}
                    mL/min/1.73 m² / year
                  </strong>
                </span>
              </p>
              <p className="note-items" style={{ marginBottom: "6px" }}>
                <span className="">
                  Based on the current ckd stage and predicted progression
                  category, we estimate that your likelihood to Deterioration to
                  Stage 5 is{" "}
                  <span
                    className={`${
                      apidata.risk_level === "High"
                        ? "red-color"
                        : apidata.risk_level === "Low"
                        ? "green-color"
                        : "yellow-color"
                    }`}
                  >
                    {apidata.risk_level}
                  </span>
                </span>
              </p>
              {(() => {
                const predictedStage =
                  apidata?.classification_model?.predicted_stage ||
                  apidata?.predicted_stage;
                const isUncertain =
                  !predictedStage ||
                  predictedStage.toString().toLowerCase().includes("uncertain");
                if (isUncertain) return null;
                return (
                  <p className="note-items">
                    <span>
                      Based on your {apidata.current_ckd_stage} and profile, we
                      estimate your condition could progress to{" "}
                      <strong>{predictedStage}</strong> within the next year.
                    </span>
                  </p>
                );
              })()}
            </div>
          </div>

          <div className="new-report-card">
            <h2 className="report-card-title">AI Recommended Protocol</h2>
            <ProtocolTable data={apidata.CDSS} />
          </div>
          <div className="new-report-card">
            <h1 className="report-card-title">
              Comprehensive care of patients with chronic kidney disease (CKD)
            </h1>
            <div className="image-container">
              <img
                src="/ckd-img.png"
                alt="ckd-reference"
                className="ckd-image"
              />
              <p>
                Reference:{" "}
                <a
                  href="https://www.bmj.com/content/383/bmj-2022-074216.full"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.bmj.com/content/383/bmj-2022-074216.full
                </a>
              </p>
            </div>
          </div>

          <div className="new-report-card">
            <h2 className="report-card-title">Disclaimer</h2>
            <Disclaimer />
          </div>
        </div>
      )}
    </div>
  );
};

export default CKDPatientReport;
